module.exports = __webpack_public_path__ + "static/media/copy.5d98b3c1.svg";